export const getLongPositions = (laborCount, days) => {
    let long = Math.floor(days / laborCount);
    let remainder = days % laborCount;

    return { long, remainder };
};
